// Full-document render of the toppers GenericPage: PageSkeleton (the React
// document shell) wrapping the reused ``GenericPageBodyTemplate`` body assembly.
// GenericPage has NO literal layout DOM -- {% block layout %}
// is ONLY ``{% if page.body %}{% include_react GenericPageBodyTemplate %}{% endif %}``
// -- so there is no wrapper element here; the body renders straight into
// PageSkeleton's ``<main>``.
import React from "react";

import { templates } from "@reactivated";

import { GenericPageBody } from "../components/GenericPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader / SiteFooter chain via PageSkeleton, which is typed with
// mutable reactivated props. GenericPageBody accepts Immutable props, to which
// these are assignable.
type IProps = templates.GenericPageTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    // GenericPageBody guards its own render: it returns null for a null body
    // and an empty StreamField (no children) for an empty stream -- both
    // reproduce the ``{% if page.body %}`` output (nothing rendered).
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <GenericPageBody page={props.page} />
        </PageSkeleton>
    );
};
